'use client';

import type { FC } from 'react';
import type { LucideIcon } from 'lucide-react';
import {
  Banknote,
  CalendarDays,
  CheckCircle2,
  MessageSquare,
  UserMinus,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import KpiCard, { type KpiCardTrend } from '@/core/presentation/components/ui/KpiCard';

const KPI_ICONS: Record<string, LucideIcon> = {
  CalendarDaysIcon: CalendarDays,
  UserMinusIcon: UserMinus,
  ChatBubbleLeftRightIcon: MessageSquare,
  CheckCircleIcon: CheckCircle2,
  BanknotesIcon: Banknote,
};

export type DashboardKpiTrendMode = 'ratio' | 'points';

export interface DashboardKpiTrend {
  value: number;
  label: string;
  mode?: DashboardKpiTrendMode;
}

export interface DashboardKpiCardProps {
  title: string;
  value: string | number;
  iconName: string;
  variant?: 'gradient' | 'plain';
  trend?: DashboardKpiTrend | null;
  subtitle?: string;
  className?: string;
}

export const DashboardKpiCard: FC<DashboardKpiCardProps> = ({
  title,
  value,
  iconName,
  variant = 'plain',
  trend,
  subtitle,
  className,
}) => {
  const Icon = KPI_ICONS[iconName] ?? CalendarDays;

  const kpiTrend: KpiCardTrend | undefined =
    trend == null ?
      undefined
    : {
        value: trend.value,
        label: trend.label,
        unit: trend.mode === 'points' ? 'pp' : 'percent',
      };

  return (
    <KpiCard
      className={cn('h-full', className)}
      title={title}
      value={value}
      subtitle={subtitle}
      icon={Icon}
      trend={kpiTrend}
      variant={variant === 'gradient' ? 'gradient' : 'default'}
    />
  );
};
